import { Injectable } from '@angular/core';
import { Filesystem, ReadFileResult } from '@capacitor/filesystem';

/**
 * Service wrapper for Capacitor Filesystem plugin.
 * Allows for proper dependency injection and testability.
 */
@Injectable({
    providedIn: 'root'
})
export class FilesystemService {
    /**
     * Read a file from the filesystem.
     */
    async readFile(options: { path: string }): Promise<ReadFileResult> {
        return Filesystem.readFile(options);
    }
}
